export default __webpack_public_path__ + "static/media/download.a5fca284.svg";